  <template >
  <div>
  <div>
  <div class="formPosition">
    <v-card style="margin:auto;" width="1200" >
    <v-card-title style="background-color:#006699;color:white;"></v-card-title>
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading  "></v-progress-linear>

    <v-data-table    :headers="headers"  :items="precos" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

        <v-btn @click="openDialog()" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon> Registrar Preços </v-btn >

                 <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Consultar os Preços de Propinas
            </v-toolbar-title>
          
          <v-divider class="mx-8" inset vertical></v-divider>

          <!--  search  -->
<div   v-if="$store.state.hasMessage && cor=='red'" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa"

            single-line
            hide-details
          ></v-text-field>
          <!-- end  search  -->
        </v-toolbar>
      </template>
      <template v-slot:item.preco="{ item }">
        <span>{{utilitarios.IntegerToMoneyValueFatura(item.preco)}}</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-menu
          bottom
          origin="center center"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab dark small
              color="#006699"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>menu</v-icon>
            </v-btn>
          </template>
          <v-list>
              <v-list-item @click="SetEditItem(item)"><v-icon color="#006699" small  >edit</v-icon>Editar</v-list-item>
              <v-list-item @click="setEliminar(item)"><v-icon color="red" small  >delete</v-icon>Eliminar</v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>
    </v-card>

    <!-- ================== DIALOGO ELIMINAR ========================================== -->

       <v-row justify="center">
          <v-dialog v-model="dialogEliminar" persistent max-width="590">
            <v-card>
              <v-card-title class="headline">Eliminar Preço de propina.</v-card-title>
              <v-card-text>Deseja continuar com essa operação?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="Eliminar()">Concordar</v-btn>
                <v-btn color="error" text @click="dialogEliminar=false">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>




    <!-- ================================================================================= -->


    <!-- ============================== DIALOGO TO SAVE MONTH PRICES ====================== -->


      <template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogPrices"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-title style="background-color:#006699;color:white;">
          <span class="text-h5">Registrar preço de propinas</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                 <v-combobox
                    v-model="price_obj.curso"
                    :rules="ruleRequired"
                    item-value="idCurso"
                    item-text="descricao"
                    :items="cursos"
                    @change="loadclasse()"
                      chips
                    label="Selecione o Curso"
                  ></v-combobox>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
               <v-combobox
                  v-model="price_obj.classe"
                  :rules="ruleRequired"
                  item-value="pkAnoacademico"
                  item-text="descricao"
                  :items="classesFiltered"
                    chips
                  label="Selecione a Classe"
                ></v-combobox>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="12"
              >
                <v-text-field
                        v-money="money"
                        v-model="price_obj.valor"
                        label="Insira o Valor"
                      ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*Preencha correctamente os campos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black darken-1"
            text
            @click="dialogPrices = false"
          >
            fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="Guardar()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </template>





    <!-- ===================================================================================== -->
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    price_obj:{
      curso:'',
      classe:'',
      valor:''
    },
    price_objDefault:{
      curso:'',
      classe:'',
      valor:''
    },
    overlay: false,
    utilitarios:utilitarios,
    dialogPrices: false,
    datebi: null,
    date: null,
    descricao: 'Nº do Bi',
    contas: [],
    valid: true,
    menu: false,
    menubi: false,
    dialogEliminar:false,
    habilitaBi: false,
    progresso: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    valorFormatado: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    precos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],

    searchInDb: '',
    classesFiltered: [],
    estudantes: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Curso',
        align: 'left',
        sortable: false,
        value: 'curso'
      },

      { text: 'Classe', value: 'classe' },
      { text: 'Preço', value: 'preco' },
      { text: 'data cadastro', value: 'data_' },
      { text: 'Autor', value: 'autor' },
      { text: 'Actions', value: 'action', sortable: false }

    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    msg: '',
    editedIndex: -1,

    editedItem: {
      ano_lectivo: 0,
      autor: '',
      classe: '',
      created_at: '',
      curso: '',
      data_cadastro: '',
      fk_classe: 0,
      fk_curso: 0,
      fk_definir_precario_propina: 0,
      instituicao: 0,
      nome: '',
      pk_classe: 0,
      pk_curso: 0,
      pk_definir_precario_propina: 0,
      preco: 0,
      status_classe: 0,
      status_curso: 0,
      status_definir_precario_propina: 0,
      valor_descricao: ''

    },
    defaultItem: {

    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },

    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select

     this.initialize()
     this.initializeCursos()
     this.initializeClasses()
     this.initializePrecosPropina()
  },

  methods: {
    async initializePrecosPropina () {
      try {
        this.isLoading = true
        this.precos = await axios
          .get('/precoPropinasFindAll')
          .then(res => res.data)
        console.log(this.precos);
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initialize (searchInDb) {
      try {
        //   let  payload =""

        this.isLoading = true
        this.precos = await axios
          .get('/precoPropinasFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.descricao = 'Nº do Bi'
      } else {
        this.descricao = 'Outro Doc.'
      }
    },

   async Eliminar(){

        try {
          
          let result = await axios.post('eliminarPrecoPropina',this.editedItem)
          if(result.data.affectedRows >= 1){
             let index = this.precos.indexOf(this.editedItem)
              this.precos.splice(index,1)
              this.dialogEliminar = false
          }
        } catch (error) {
          
        } 

    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    
    async initializeClasses () {
      try {
        this.isLoading = true
        this.classes = await axios
          .get('/classeFindAll2')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    
    SetEditItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    setEliminar (item){
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogEliminar = true
    },
 

    async delete (idv) {
      try {
        var msg = await axios
          .get('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        console.log('eroooo: ' + error)
        this.text = error.message
      } finally {

      }
    },
    /**
     * =================================== FOR SAVING PRICES CODES
     */
    openDialog (){
      this.dialogPrices = true
    },

    loadclasse () {
       this.classesFiltered = this.classes.filter(c=>c.nivel === this.price_obj.curso.nivel_ensino)
    },

   async Guardar () {


        let precoExistente = this.precos.filter(p => p.classe_id === this.price_obj.classe.pkAnoacademico && p.curso_id === this.price_obj.curso.idCurso)
        if (!precoExistente.length) { // verifica se já foi definido o valor para este curso e classe
         try {
            this.overlay = true
            let params = {
              id:0,
              preco: utilitarios.MoneyValueToInteger(this.price_obj.valor),
              classe_id: this.price_obj.classe.pkAnoacademico,
              classe: this.price_obj.classe.descricao,
              curso_id: this.price_obj.curso.idCurso,
              curso: this.price_obj.curso.descricao,
              autor: ls.get('nomeUsuario')
            }
            let result = await axios.post('precoPropinaInsertOrUpdate',params).then(res => res.data)
            if(result.affectedRows >= 1){
              utilitarios.showAlertMessage('success','Registro efectuado com sucesso.')
              this.dialogPrices = false
              this.price_obj = this.price_objDefault
              this.initializePrecosPropina()
            }else{
               utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.')
            }

         } catch (error) {
           this.overlay = false
           utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.')
         }finally{this.overlay = false}
      }else{
        this.overlay = false
        utilitarios.showAlertMessage('warning','Ja foi definido o valor da mensalidade para este curso e classe.')
      }

   }


  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
